import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/AuthContext";
import AuthCallback from "./pages/AuthCallback";
import Login from "./pages/Login";
import AppLayout from "./components/AppLayout";
import Dashboard from "./pages/Dashboard";
import Proposals from "./pages/Proposals";
import ProposalEditor from "./pages/ProposalEditor";
import PublicProposal from "./pages/PublicProposal";
import PublicContract from "./pages/PublicContract";
import ItemsLibrary from "./pages/ItemsLibrary";
import Templates from "./pages/Templates";
import Settings from "./pages/Settings";
import Contracts from "./pages/Contracts";
import Trainings from "./pages/Trainings";
import TrainingEditor from "./pages/TrainingEditor";
import PublicAttendance from "./pages/PublicAttendance";
import PublicVerifyCertificate from "./pages/PublicVerifyCertificate";
import PublicPortal from "./pages/PublicPortal";
import PortalQRProjection from "./pages/PortalQRProjection";
import Events from "./pages/Events";
import EventEditor from "./pages/EventEditor";
import Vendors from "./pages/Vendors";
import PublicEventCheckIn from "./pages/PublicEventCheckIn";
import PublicEventNPS from "./pages/PublicEventNPS";
import Prospecting from "./pages/Prospecting";
import CampaignEditor from "./pages/CampaignEditor";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center overline">Carregando…</div>;
  if (!user) return <Navigate to="/" replace />;
  return <AppLayout>{children}</AppLayout>;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<HomeGate />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/proposals" element={<Protected><Proposals /></Protected>} />
      <Route path="/proposals/new" element={<Protected><ProposalEditor /></Protected>} />
      <Route path="/proposals/:id" element={<Protected><ProposalEditor /></Protected>} />
      <Route path="/contracts" element={<Protected><Contracts /></Protected>} />
      <Route path="/trainings" element={<Protected><Trainings /></Protected>} />
      <Route path="/trainings/new" element={<Protected><TrainingEditor /></Protected>} />
      <Route path="/trainings/:id" element={<Protected><TrainingEditor /></Protected>} />
      <Route path="/trainings/:id/scanner" element={<Protected><TrainingScanner /></Protected>} />
      <Route path="/events" element={<Protected><Events /></Protected>} />
      <Route path="/events/:id" element={<Protected><EventEditor /></Protected>} />
      <Route path="/vendors" element={<Protected><Vendors /></Protected>} />
      <Route path="/prospecting" element={<Protected><Prospecting /></Protected>} />
      <Route path="/prospecting/campaigns/:id" element={<Protected><CampaignEditor /></Protected>} />
      <Route path="/items" element={<Protected><ItemsLibrary /></Protected>} />
      <Route path="/templates" element={<Protected><Templates /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="/p/:token" element={<PublicProposal />} />
      <Route path="/c/:token" element={<PublicContract />} />
      <Route path="/presenca/:token" element={<PublicAttendance />} />
      <Route path="/verificar/:code" element={<PublicVerifyCertificate />} />
      <Route path="/portal/:slug" element={<PublicPortal />} />
      <Route path="/portal-qr/:slug" element={<PortalQRProjection />} />
      <Route path="/checkin-evento/:token" element={<PublicEventCheckIn />} />
      <Route path="/nps-evento/:token" element={<PublicEventNPS />} />
    </Routes>
  );
}

function HomeGate() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center overline">Carregando…</div>;
  if (user) return <Navigate to="/dashboard" replace />;
  return <Login />;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
